import {
  colorFix,
  formatVolume10,
  numberFormat,
  StringToDouble,
  StringToInt,
} from '../utils';

let arrUpdate = [];

export function _testUpdateId() {
  let _root = document.getElementById('TCBbP3');
  if (!_root) return;
  console.log(_root);
  // console.log(_root.childNodes)
  console.log(_root.children[0].innerHTML);
  _root.children[0].innerHTML = 19.75;
  console.log(_root.children[0].innerHTML);
  console.log(_root.classList);
  _root.classList.add('active');
  setTimeout(() => {
    _root.classList.remove('active');
  }, 500);
}

export function _testProcessG(sym, data, idPrice, idVol) {
  if (!sym) return;

  const _type = sym.startsWith('VN30F') ? 'D' : 'A';
  let _rootPrice = document.getElementById(sym + idPrice);
  let _rootVol = document.getElementById(sym + idVol);

  if (!_rootPrice) return;

  const _g = data.split('|');

  const _oldVol = StringToInt(_rootVol.children[0].innerHTML);

  const price = _g[0];
  const vol = StringToInt(_g[1]);
  const clp = _g[0] === 'ATO' || _g[0] === 'ATC' ? '' : _g[2];
  const clv = _oldVol < vol ? 'i' : _oldVol > vol ? 'd' : clp;

  const _oldPrice = _rootPrice.children[0].innerHTML;
  const _newPrice = numberFormat(price, _type === 'D' ? 1 : 2);

  if (_oldPrice !== _newPrice) {
    if (!arrUpdate[sym + idPrice] && _rootPrice) {
      _rootPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
      if (clp && _rootPrice) {
        _rootPrice.classList.add(clp, 'active');
      }
      arrUpdate[sym + idPrice] = true;
    }
    _rootPrice.children[0].innerHTML = _newPrice;
  }

  if (_oldVol !== vol) {
    const _newVol = _type === 'D' ? numberFormat(vol) : formatVolume10(vol);
    if (!arrUpdate[sym + idVol] && _rootVol) {
      _rootVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
      if (clv) _rootVol.classList.add(clv, 'active');
      arrUpdate[sym + idVol] = true;
    }
    _rootVol.children[0].innerHTML = _newVol;
  }

  if (arrUpdate[sym + idPrice]) {
    setTimeout(() => {
      arrUpdate[sym + idPrice] = false;
      if (clp) {
        if (_rootPrice) {
          _rootPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f', 'active');
          _rootPrice.classList.add(clp);
        }
      }
    }, 500);
  }
  if (arrUpdate[sym + idVol]) {
    setTimeout(() => {
      arrUpdate[sym + idVol] = false;
      if (clv && _rootVol) {
        _rootVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f', 'active', clv);
        _rootVol.classList.add(clp);
      }
    }, 500);
  }
}

export function _testProcess3210(data) {
  _testProcessG(data.sym, data.g1, 'bP1', 'bV1');
  _testProcessG(data.sym, data.g2, 'bP2', 'bV2');
  _testProcessG(data.sym, data.g3, 'bP3', 'bV3');
  _testProcessG(data.sym, data.g4, 'oP1', 'oV1');
  _testProcessG(data.sym, data.g5, 'oP2', 'oV2');
  _testProcessG(data.sym, data.g6, 'oP3', 'oV3');
}

export function _process3210(data) {
  if (data.side === 'B') {
    _testProcessG(data.sym, data.g1, 'bP1', 'bV1');
    _testProcessG(data.sym, data.g2, 'bP2', 'bV2');
    _testProcessG(data.sym, data.g3, 'bP3', 'bV3');

    if(data.vol4)
      _processDuMuaBan(data.sym, data.vol4, 'duMua');
  } else {
    _testProcessG(data.sym, data.g1, 'oP1', 'oV1');
    _testProcessG(data.sym, data.g2, 'oP2', 'oV2');
    _testProcessG(data.sym, data.g3, 'oP3', 'oV3');
    if(data.vol4)
      _processDuMuaBan(data.sym, data.vol4, 'duBan');
  }
}

export function _process3250(data) {
  const _type = data.symbol.startsWith('VN30F') ? 'D' : 'A';
  let _rootFBVol = document.getElementById(data.symbol + 'fBVol');
  let _rootFSVol = document.getElementById(data.symbol + 'fSVol');
  let _rootFRoom = document.getElementById(data.symbol + 'fRoom');

  if (!_rootFBVol || !_rootFSVol) return;
  // console.log(data)
  _rootFBVol.innerHTML =
    _type === 'D' ? numberFormat(data.fBVol) : formatVolume10(data.fBVol);
  _rootFSVol.innerHTML =
    _type === 'D' ? numberFormat(data.fSVolume) : formatVolume10(data.fSVolume);
  _rootFRoom.innerHTML =
    _type === 'D' ? numberFormat(data.fRoom) : formatVolume10(data.fRoom);

  _rootFBVol.classList.add('active');
  _rootFSVol.classList.add('active');
  _rootFRoom.classList.add('active');

  setTimeout(() => {
    if (_rootFBVol) _rootFBVol.classList.remove('active');
    if (_rootFSVol) _rootFSVol.classList.remove('active');
    if (_rootFRoom) _rootFRoom.classList.remove('active');
  }, 500);
}

export function _processDuMuaBan(sym, data, idVol) {
  const _type = sym.startsWith('VN30F') ? 'D' : 'A';
  let _rootDuMuaBan = document.getElementById(sym + idVol);

  if (!_rootDuMuaBan || data < 1) return;

  _rootDuMuaBan.innerHTML =
    _type === 'D' ? numberFormat(data) : formatVolume10(data);

  _rootDuMuaBan.classList.add('active');

  setTimeout(() => {
    if (_rootDuMuaBan) _rootDuMuaBan.classList.remove('active');
  }, 500);
}

export function _process3220(data) {
  let _rootLastPrice = document.getElementById(data.sym + 'lastPrice');
  let _rootLastVol = document.getElementById(data.sym + 'lastVolume');
  let _rootChange = document.getElementById(data.sym + 'change');
  let _rootChangePc = document.getElementById(data.sym + 'changePc');
  let _rootLot = document.getElementById(data.sym + 'lot');
  let _rootHighP = document.getElementById(data.sym + 'highP');
  let _rootLowP = document.getElementById(data.sym + 'lowP');
  let _rootAveP = document.getElementById(data.sym + 'aveP');
  let _rootSym = document.getElementById(data.sym + 'sym');
  let _rootOther = document.getElementById(data.sym + 'other');
  let _rootVN30 = document.getElementById('index_11');

  if (!_rootSym || !_rootLastVol) return;

  const _type = data.sym.startsWith('VN30F') ? 'D' : 'A';

  // const c = document.getElementById(data.sym + 'ceil').innerHTML
  // const r = document.getElementById(data.sym + 'ref').innerHTML
  // const f = document.getElementById(data.sym + 'floor').innerHTML

  // const clHigh = colorFix( data.highPrice, r, c, f, r );
  // const clLow = colorFix( data.lowPrice, r, c, f, r );
  // const clAve = colorFix( data.avePrice, r, c, f, r );

  const _oldPrice = _rootLastPrice.children[0].innerHTML;
  const _newPrice = numberFormat(data.lastPrice, _type === 'D' ? 1 : 2);
  const _oldVol = _rootLastVol.children[0].innerHTML;
  const _newVol =
    _type === 'D' ? numberFormat(data.lastVol) : formatVolume10(data.lastVol);

  if (_rootHighP) _rootHighP.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
  if (_rootLowP) _rootLowP.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
  if (_rootAveP) _rootAveP.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
  if (_rootSym) _rootSym.classList.remove('d', 'e', 'i', 'r', 'c', 'f');

  if (_oldPrice !== _newPrice && _rootLastPrice) {
    _rootLastPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastPrice.children[0].innerHTML = _newPrice;

    _rootLastPrice.classList.add(data.cl, 'active');
  }
  if (_oldVol !== _newVol && _rootLastVol) {
    _rootLastVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastVol.children[0].innerHTML = _newVol;

    _rootLastVol.classList.add(data.cl, 'active');
  }

  if (_rootLot && data.totalVol) {
    _rootLot.innerHTML =
      _type === 'D'
        ? numberFormat(data.totalVol)
        : formatVolume10(data.totalVol);
    _rootLot.classList.add('active');
  }
  if (_rootHighP)
    _rootHighP.innerHTML = numberFormat(data.hp, _type === 'D' ? 1 : 2);
  if (_rootLowP)
    _rootLowP.innerHTML = numberFormat(data.lp, _type === 'D' ? 1 : 2);
  if (_rootAveP)
    _rootAveP.innerHTML = numberFormat(data.ap, _type === 'D' ? 1 : 2);

  if (_rootChange) {
    _rootChange.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootChange.innerHTML =
      (data.cl === 'd' ? '-' : '') +
      numberFormat(data.change, _type === 'D' ? 1 : 2);
    _rootChange.classList.add(data.cl);
  }
  if (_rootChangePc) {
    _rootChangePc.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootChangePc.innerHTML =
      (data.cl === 'd' ? '-' : '') +
      numberFormat(data.changePc, _type === 'D' ? 1 : 2) +
      '%';
    _rootChangePc.classList.add(data.cl);
  }

  if (_rootHighP) _rootHighP.classList.add(data.ch);
  if (_rootLowP) _rootLowP.classList.add(data.lc);
  if (_rootAveP) _rootAveP.classList.add(data.ca);
  if (_rootSym) _rootSym.classList.add(data.cl);

  // console.log(data.ch, data.lc, data.ca)

  if (_type === 'D') {
    // phái sinh
    if (_rootVN30) {
      const _valVN30 = StringToDouble(_rootVN30.innerHTML);
      if (_rootOther && _valVN30) {
        _rootOther.classList.remove('d', 'i', 'r');
        _rootOther.innerHTML = numberFormat(data.lastPrice - _valVN30, 2);
        _rootOther.classList.add(
          _valVN30 < data.lastPrice
            ? 'i'
            : _valVN30 > data.lastPrice
            ? 'd'
            : 'r'
        );
      }
    }
  }

  setTimeout(() => {
    if (_rootLastPrice) _rootLastPrice.classList.remove('active');
    if (_rootLastVol) _rootLastVol.classList.remove('active');
    if (_rootLot) _rootLot.classList.remove('active');
  }, 500);
}

export function _process3310(data) {
  let _rootDuMua = document.getElementById(data.sym + 'duMua');
  let _rootDuBan = document.getElementById(data.sym + 'duBan');
  let _rootlot = document.getElementById(data.sym + 'lot');

  const _type = data.sym.startsWith('VN30F') ? 'D' : 'A';

  if (_rootlot) {
    const _oldVol =
      _type === 'D'
        ? StringToInt(_rootlot.innerHTML)
        : StringToInt(_rootlot.innerHTML) * 10;
    if (_oldVol < data.Total) {
      _rootlot.innerHTML =
        _type === 'D' ? numberFormat(data.Total) : formatVolume10(data.Total);
      _rootlot.classList.add('active');
    }
  }
  if (_rootDuMua) {
    const _oldVol = StringToInt(_rootDuMua.innerHTML);
    if (_oldVol !== data.BVolume) {
      _rootDuMua.innerHTML = formatVolume10(data.BVolume);
      _rootDuMua.classList.add('active');
    }
  }
  if (_rootDuBan) {
    const _oldVol = StringToInt(_rootDuBan.innerHTML);
    if (_oldVol !== data.SVolume) {
      _rootDuBan.innerHTML = formatVolume10(data.SVolume);
      _rootDuBan.classList.add('active');
    }
  }

  setTimeout(() => {
    if (_rootDuMua) _rootDuMua.classList.remove('active');
    if (_rootDuBan) _rootDuBan.classList.remove('active');
    if (_rootlot) _rootlot.classList.remove('active');
  }, 500);
}

export function _process9100(data) {
  _testProcessG(
    data.sym,
    data.bp1 +
      '|' +
      data.bv1 +
      '|' +
      colorFix(data.bp1, data.r, data.c, data.f, data.r),
    'bP1Odd',
    'bV1Odd'
  );
  _testProcessG(
    data.sym,
    data.bp2 +
      '|' +
      data.bv2 +
      '|' +
      colorFix(data.bp2, data.r, data.c, data.f, data.r),
    'bP2Odd',
    'bV2Odd'
  );
  _testProcessG(
    data.sym,
    data.bp3 +
      '|' +
      data.bv3 +
      '|' +
      colorFix(data.bp3, data.r, data.c, data.f, data.r),
    'bP3Odd',
    'bV3Odd'
  );
  _testProcessG(
    data.sym,
    data.sp1 +
      '|' +
      data.sv1 +
      '|' +
      colorFix(data.sp1, data.r, data.c, data.f, data.r),
    'oP1Odd',
    'oV1Odd'
  );
  _testProcessG(
    data.sym,
    data.sp2 +
      '|' +
      data.sv2 +
      '|' +
      colorFix(data.sp2, data.r, data.c, data.f, data.r),
    'oP2Odd',
    'oV2Odd'
  );
  _testProcessG(
    data.sym,
    data.sp3 +
      '|' +
      data.sv3 +
      '|' +
      colorFix(data.sp3, data.r, data.c, data.f, data.r),
    'oP3Odd',
    'oV3Odd'
  );

  let _rootLastPrice = document.getElementById(data.sym + 'lastPriceOdd');
  let _rootLastVol = document.getElementById(data.sym + 'lastVolumeOdd');
  let _rootChange = document.getElementById(data.sym + 'changeOdd');

  if (!_rootLastPrice) return;
  const _oldPrice = _rootLastPrice.children[0].innerHTML;
  const _newPrice = numberFormat(data.lastPrice, 2);
  const _oldVol = _rootLastVol.children[0].innerHTML;
  const _newVol = formatVolume10(data.lastVol);

  const _cl = colorFix(data.lastPrice, data.r, data.c, data.f, data.r);

  if (_oldPrice !== _newPrice && _rootLastPrice) {
    _rootLastPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastPrice.children[0].innerHTML = _newPrice;

    _rootLastPrice.classList.add(_cl, 'active');
  }
  if (_oldVol !== _newVol && _rootLastVol) {
    _rootLastVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastVol.children[0].innerHTML = _newVol;

    _rootLastVol.classList.add(_cl, 'active');
  }

  if (_rootChange) {
    _rootChange.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootChange.innerHTML =
      (_cl === 'd' ? '-' : '') + numberFormat(data.lastPrice - data.r, 2);
    _rootChange.classList.add(_cl);
  }

  setTimeout(() => {
    if (_rootLastPrice) _rootLastPrice.classList.remove('active');
    if (_rootLastVol) _rootLastVol.classList.remove('active');
  }, 500);
}

export function _process6210(data) {
  if (data.side === 'B') {
    _testProcessGLoLe(data.sym, data.g1, 'bP1', 'bV1');
    _testProcessGLoLe(data.sym, data.g2, 'bP2', 'bV2');
    _testProcessGLoLe(data.sym, data.g3, 'bP3', 'bV3');
  } else {
    _testProcessGLoLe(data.sym, data.g1, 'oP1', 'oV1');
    _testProcessGLoLe(data.sym, data.g2, 'oP2', 'oV2');
    _testProcessGLoLe(data.sym, data.g3, 'oP3', 'oV3');
  }
}

export function _process6220(data) {
  let _rootLastPrice = document.getElementById(data.sym + 'lastPrice');
  let _rootLastVol = document.getElementById(data.sym + 'lastVolume');
  let _rootChange = document.getElementById(data.sym + 'change');
  let _rootChangePc = document.getElementById(data.sym + 'changePc');
  let _rootSym = document.getElementById(data.sym + 'sym');

  if (!_rootSym || !_rootLastVol) return;

  const _oldPrice = _rootLastPrice.innerHTML;
  const _newPrice = numberFormat(data.lastPrice, 2);
  const _oldVol = _rootLastVol.innerHTML;
  const _newVol = numberFormat(data.lastVol);

  if (_rootSym) _rootSym.classList.remove('d', 'e', 'i', 'r', 'c', 'f');

  if (_oldPrice !== _newPrice && _rootLastPrice) {
    _rootLastPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastPrice.innerHTML = _newPrice;

    _rootLastPrice.classList.add(data.cl, 'active');
  }
  if (_oldVol !== _newVol && _rootLastVol) {
    _rootLastVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootLastVol.innerHTML = _newVol;

    _rootLastVol.classList.add(data.cl, 'active');
  }

  if (_rootChange) {
    _rootChange.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootChange.innerHTML =
      (data.cl === 'd' ? '-' : '') + numberFormat(data.change, 2);
    _rootChange.classList.add(data.cl);
  }
  if (_rootChangePc) {
    _rootChangePc.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootChangePc.innerHTML =
      (data.cl === 'd' ? '-' : '') + numberFormat(data.changePc, 2) + '%';
    _rootChangePc.classList.add(data.cl);
  }

  if (_rootSym) _rootSym.classList.add(data.cl);

  setTimeout(() => {
    if (_rootLastPrice) _rootLastPrice.classList.remove('active');
    if (_rootLastVol) _rootLastVol.classList.remove('active');
  }, 500);
}

export function _testProcessGLoLe(sym, data, idPrice, idVol) {
  if (!sym) return;

  const _type = sym.startsWith('VN30F') ? 'D' : 'A';

  let _rootPrice = document.getElementById(sym + idPrice);
  let _rootVol = document.getElementById(sym + idVol);

  if (!_rootPrice) return;

  const _g = data.split('|');

  const _oldVol = StringToInt(_rootVol.innerHTML);

  // console.log(_rootVol.children[0])

  const price = _g[0];
  const vol = StringToInt(_g[1]);
  const clp = _g[0] === 'ATO' || _g[0] === 'ATC' ? '' : _g[2];
  const clv = _oldVol < vol ? 'i' : _oldVol > vol ? 'd' : clp;

  const _oldPrice = _rootPrice.innerHTML;
  const _newPrice = numberFormat(price, _type === 'D' ? 1 : 2);

  if (_oldPrice !== _newPrice) {
    if (!arrUpdate[sym + idPrice])
      _rootPrice.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootPrice.innerHTML = _newPrice;

    if (clp && !arrUpdate[sym + idPrice]) {
      arrUpdate[sym + idPrice] = true;
      _rootPrice.classList.add(clp, 'active');
    }
  }

  if (_oldVol !== vol) {
    const _newVol = _type === 'D' ? numberFormat(vol) : formatVolume10(vol);
    if (!arrUpdate[sym + idVol])
      _rootVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f');
    _rootVol.innerHTML = _newVol;

    if (clv && !arrUpdate[sym + idVol]) {
      arrUpdate[sym + idVol] = true;
      _rootVol.classList.add(clv, 'active');
    }
  }

  if (arrUpdate[sym + idPrice]) {
    setTimeout(() => {
      arrUpdate[sym + idPrice] = false;
      if (clp) _rootPrice.classList.remove('active');
    }, 500);
  }
  if (arrUpdate[sym + idVol]) {
    setTimeout(() => {
      arrUpdate[sym + idVol] = false;
      if (clv) {
        _rootVol.classList.remove('d', 'e', 'i', 'r', 'c', 'f', 'active');
        if (clp) _rootVol.classList.add(clp);
      }
    }, 500);
  }
}
